import { useSyncExternalStore } from "react";

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange: () => void): (() => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return (): void => list.removeEventListener("change", onChange);
    },
    (): boolean => window.matchMedia(query).matches,
    (): boolean => false
  );
}
